import React from 'react';
import { Box, Heading, Text, Flex, Separator } from '@radix-ui/themes';
import Markdown from 'react-markdown';

const Section = ({ title, children }) => (
  <Box mb="3">
    <Heading size="2" mb="1">{title}</Heading>
    {children}
  </Box>
);

const LessonNotesView = ({ notes }) => {

    // console.log('notes', notes);

  if (!notes) {
    return <Text color="red">No lesson notes available.</Text>;
  }

  return (
    <Box width="100%" maxWidth="800px" mx="auto">
      {/* Teaching Style with accent background and light text */}
      {notes.teaching_style && (
        <Box mb="4" p="3" style={{ background: 'var(--accent-9)', color: 'var(--accent-1)', borderRadius: 8 }}>
          <Heading size="2" mb="2" style={{ color: 'var(--accent-2)' }}>Teaching Style</Heading>
          <Text size="1"><Markdown>{notes.teaching_style}</Markdown></Text>
        </Box>
      )}

      {/* Topics Section */}
      {Array.isArray(notes.topics) && notes.topics.length > 0 && (
        <>
          <Section title="Topics">
            <Flex direction="column" gap="3">
              {notes.topics.map((topic, idx) => (
                <React.Fragment key={idx}>
                  <Box mb="2">
                    <Heading size="2" mb="1" style={{ color: 'var(--accent-9)' }}>{topic.title}</Heading>
                    {topic.lesson && <Text size="1" weight="bold">Lesson: {topic.lesson}</Text>}
                    {topic.notes && (
                      <Box mt="1">
                        <Text size="1"><Markdown>{topic.notes}</Markdown></Text>
                      </Box>
                    )}
                  </Box>
                  {idx < notes.topics.length - 1 && <Separator my="2" />}
                </React.Fragment>
              ))}
            </Flex>
          </Section>
          <Separator size="4" my="4" />
        </>
      )}

      {notes.engagement_strategies && (
        <Section title="Engagement Strategies">
          <Text size="1"><Markdown>{notes.engagement_strategies}</Markdown></Text>
        </Section>
      )}

      {notes.formative_assessment_ideas && (
        <Section title="Formative Assessment Ideas">
          <Text size="1"><Markdown>{notes.formative_assessment_ideas}</Markdown></Text>
        </Section>
      )}

      {notes.differentiated_instruction_tips && (
        <Section title="Differentiated Instruction Tips">
          <Text size="1"><Markdown>{notes.differentiated_instruction_tips}</Markdown></Text>
        </Section>
      )}

      {notes.follow_up_activities && (
        <Section title="Follow-up Activities">
          <Text size="1"><Markdown>{notes.follow_up_activities}</Markdown></Text>
        </Section>
      )}
    </Box>
  );
};

export default LessonNotesView;
